import createIcon from '../../createIcon';

/**
 * @component @name DatasetLinked
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNi41OSAxNi41SDUuNVYxMi41SDkuMTlDMTAuMTQgMTEuODcgMTEuMjggMTEuNSAxMi41IDExLjVIMTguNUMxOC44NCAxMS41IDE5LjE3IDExLjU0IDE5LjUgMTEuNTlWNC41QzE5LjUgMy40IDE4LjYgMi41IDE3LjUgMi41SDMuNUMyLjQgMi41IDEuNSAzLjQgMS41IDQuNVYxOC41QzEuNSAxOS42IDIuNCAyMC41IDMuNSAyMC41SDcuMzFDNi44IDE5LjYyIDYuNSAxOC41OSA2LjUgMTcuNUM2LjUgMTcuMTYgNi41NCAxNi44MyA2LjU5IDE2LjVaTTExLjUgNi41SDE1LjVWMTAuNUgxMS41VjYuNVpNNS41IDYuNUg5LjVWMTAuNUg1LjVWNi41WiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTEwLjUgMTcuNUMxMC41IDE2LjQgMTEuNCAxNS41IDEyLjUgMTUuNUgxNC41VjEzLjVIMTIuNUMxMC4yOSAxMy41IDguNSAxNS4yOSA4LjUgMTcuNUM4LjUgMTkuNzEgMTAuMjkgMjEuNSAxMi41IDIxLjVIMTQuNVYxOS41SDEyLjVDMTEuNCAxOS41IDEwLjUgMTguNiAxMC41IDE3LjVaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNMTguNSAxMy41SDE2LjVWMTUuNUgxOC41QzE5LjYgMTUuNSAyMC41IDE2LjQgMjAuNSAxNy41QzIwLjUgMTguNiAxOS42IDE5LjUgMTguNSAxOS41SDE2LjVWMjEuNUgxOC41QzIwLjcxIDIxLjUgMjIuNSAxOS43MSAyMi41IDE3LjVDMjIuNSAxNS4yOSAyMC43MSAxMy41IDE4LjUgMTMuNVoiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik0xOC41IDE2LjVIMTIuNVYxOC41SDE4LjVWMTYuNVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const DatasetLinked = createIcon('DatasetLinked', [
  [
    'path',
    {
      d: 'M6.59 16.5H5.5V12.5H9.19C10.14 11.87 11.28 11.5 12.5 11.5H18.5C18.84 11.5 19.17 11.54 19.5 11.59V4.5C19.5 3.4 18.6 2.5 17.5 2.5H3.5C2.4 2.5 1.5 3.4 1.5 4.5V18.5C1.5 19.6 2.4 20.5 3.5 20.5H7.31C6.8 19.62 6.5 18.59 6.5 17.5C6.5 17.16 6.54 16.83 6.59 16.5ZM11.5 6.5H15.5V10.5H11.5V6.5ZM5.5 6.5H9.5V10.5H5.5V6.5Z',
      key: 'tk50e1',
    },
  ],
  [
    'path',
    {
      d: 'M10.5 17.5C10.5 16.4 11.4 15.5 12.5 15.5H14.5V13.5H12.5C10.29 13.5 8.5 15.29 8.5 17.5C8.5 19.71 10.29 21.5 12.5 21.5H14.5V19.5H12.5C11.4 19.5 10.5 18.6 10.5 17.5Z',
      key: '1iam9v',
    },
  ],
  [
    'path',
    {
      d: 'M18.5 13.5H16.5V15.5H18.5C19.6 15.5 20.5 16.4 20.5 17.5C20.5 18.6 19.6 19.5 18.5 19.5H16.5V21.5H18.5C20.71 21.5 22.5 19.71 22.5 17.5C22.5 15.29 20.71 13.5 18.5 13.5Z',
      key: 'igs6rb',
    },
  ],
  ['path', { d: 'M18.5 16.5H12.5V18.5H18.5V16.5Z', key: '1kvniw' }],
]);

export default DatasetLinked;
